var _path, _rect, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTabAlbum(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 16.3535V7.04868H22V16.428C22 20.2646 19.5851 22.6235 15.7212 22.6235H6.26674C2.43908 22.6235 0 20.2157 0 16.3535ZM7.82891 13.8632C8.95143 13.8632 9.86501 12.9496 9.86501 11.8271C9.86501 10.7046 8.95143 9.79019 7.82891 9.79019C6.70556 9.79019 5.7928 10.7046 5.7928 11.8271C5.7928 12.9496 6.70556 13.8632 7.82891 13.8632ZM16.9651 15.6616C16.875 15.4363 16.7381 15.2249 16.5472 15.0397C16.0466 14.5555 15.5788 14.1032 15.0224 13.7689C14.1498 13.238 13.4746 13.9836 13.2927 14.222C13.1461 14.4146 13.0166 14.6238 12.8852 14.8361L12.8852 14.8362L12.885 14.8365C12.8594 14.8779 12.8336 14.9195 12.8077 14.9611L12.7999 14.9736C12.4133 15.5967 11.9692 16.3126 11.2042 16.7309C10.085 17.334 9.23528 16.7784 8.62404 16.3737C8.39462 16.2229 8.17175 16.0795 7.9497 15.9845C7.40237 15.7542 6.90994 16.0164 6.17907 16.921C5.79561 17.3938 5.41543 17.8624 5.03033 18.3295C4.80009 18.6097 4.85498 19.0399 5.16552 19.2267C5.66123 19.5249 6.26592 19.6839 6.94927 19.6839H13.8163C14.2039 19.6839 14.5922 19.6331 14.9626 19.5143C15.7967 19.2488 16.4587 18.6417 16.8045 17.8379C17.0962 17.1627 17.238 16.3433 16.9651 15.6616Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.11108,
    y: 3.06793,
    width: 9.77778,
    height: 1.83333,
    rx: 0.916667,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M0.00408936 7.04856C0.0197864 6.33111 0.0801596 4.90722 0.193661 4.44889C0.773244 1.87122 2.74141 0.233444 5.5548 0H16.4461C19.2354 0.245667 21.2277 1.89444 21.8073 4.44889C21.9196 4.895 21.9799 6.32989 21.9956 7.04856H0.00408936Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabAlbum);
export default __webpack_public_path__ + "static/media/tab-album.22de4cac85b12196291d13fdbc2164fe.svg";
export { ForwardRef as ReactComponent };